//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'

import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import qs from 'qs'

import { CATALOG_ID, LANG_ID, STORE_ID } from '@/scripts/constants/parameters'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { WcsGetSupport } from '@/scripts/libs/wcs/get-support'
const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')

export default {
  name: 'rb-get-support-search-results',
  components: {
    RbLoading,
  },
  props: {
    endpoint: String,
  },
  data() {
    return {
      loading: false,
      booted: false,
      nextContentPageURL: undefined,
      selectedPageNumberContent: 1,
      contentdata: undefined,
      searchTerm: undefined,
      hasServiceBeenCalled: false,
      numberOfTotalPages: 0,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    hasContentResults() {
      return this.contentdata && this.contentdata.length !== 0
    },
    canComponentBeDisplayed() {
      return !this.hasContentResults && this.hasServiceBeenCalled
    },
    isLoadMoreVisible() {
      return this.contentdata && this.contentdata.length < this.numberOfTotalPages
    },
    getTotalPagesOfLabel() {
      const { storeId } = wcs.getStoreConfig()
      switch (storeId) {
        case WcsStoreId.SPAIN:
        case WcsStoreId.HONG_KONG:
        case WcsStoreId.POLAND:
        case WcsStoreId.CHINA: {
          const label = this.translation('get_support.pages_found').replace(
            'XX',
            this.numberOfTotalPages
          )
          return label
        }
        default:
          return `${this.numberOfTotalPages} ${this.translation('get_support.pages_found')} `
      }
    },
  },
  mounted() {
    this.loadSearch()
  },
  methods: {
    async loadSearch() {
      const searchTermEl = document.getElementById('searchTerm')
      this.searchTerm = searchTermEl && searchTermEl.value ? searchTermEl.value : ''

      let { storeId, catalogId, langId } = wcs.getStoreConfig()

      if (!storeId) {
        const storeIdEl = document.getElementById(STORE_ID)
        storeId = storeIdEl && storeIdEl.value ? storeIdEl.value : ''
      }

      if (!catalogId) {
        const catalogIdEl = document.getElementById(CATALOG_ID)
        catalogId = catalogIdEl && catalogIdEl.value ? catalogIdEl.value : ''
      }

      if (!langId) {
        const langIdEl = document.getElementById(LANG_ID)
        langId = langIdEl && langIdEl.value ? langIdEl.value : ''
      }

      const queryParams = qs.parse(window.location.search)
      const searchTerm = get(queryParams, '?searchTerm', null)
      this.searchTerm = searchTerm ? searchTerm : ''

      this.loading = true
      const response = await WcsGetSupport.getSupportSearchResults(
        this.endpoint,
        this.searchTerm,
        this.selectedPageNumberContent,
        catalogId,
        storeId,
        langId
      )
      this.loading = false
      this.booted = true

      if (response) {
        this.contentdata = !this.contentdata
          ? response.contentdata
          : this.contentdata.concat(response.contentdata)
        if (response.selectedPageNumberContent) {
          this.selectedPageNumberContent = response.selectedPageNumberContent
        }
        this.numberOfTotalPages = response.totalContentCount
        this.hasServiceBeenCalled = true
      }
    },
    async loadMorePages() {
      this.selectedPageNumberContent++
      this.loadSearch()
    },
  },
}
